import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import { useBank } from '../../../contexts/banks-context';
import NewBank from '../new-bank/new-bank';
import { renderPaginator } from '../../../utils/functions';

const ListBanks = (props) => {
	const { getBanks, deleteBank } = useBank();
	const [banks, setBanks] = useState(null);
	const [search, setSearch] = useState(null);
	const [filter] = useState(null);

	const limit = 12;
	const [offset, setOffset] = useState(0);
	const [pagination, setPagination] = useState(null);

	const [showNewBank, setShowNewBank] = useState(false);

	useEffect(() => {
		const initBanks = async () => {
			const { data } = await getBanks(search, filter === 'null' ? null : filter, limit, offset);
			setBanks(data.data);
			renderPaginator(data.length, limit, setOffset, setPagination, offset);
		}

		initBanks();
	}, [filter, limit, offset, search, getBanks]);

	const handleDeleteBank = async (id) => {
		const confirmDelete = window.confirm('Sei sicuro di voler eliminare la banca?');

		if (!confirmDelete) {
			return;
		}

		const { error } = await deleteBank(id);

		if (error !== null) {
			return console.log('Impossibile eliminare la banca');
		}

		const { data } = await getBanks(search, filter === 'null' ? null : filter, limit, offset);
		setBanks(data.data);
		renderPaginator(data.length, limit, setOffset, setPagination, offset);
	}

	const handleSearch = async () => {
		const { data } = await getBanks(search, filter === 'null' ? null : filter, limit, offset);
		setBanks(data.data);
		renderPaginator(data.length, limit, setOffset, setPagination, offset);
	}

	return (
		<div className="list-Banks-page">
			<div className="top-bar">
				<button className="btn btn-primary" onClick={() => setShowNewBank(!showNewBank)}>Nuova Banca</button>

				{/* <select className="form-select d-inline w-auto mx-2" onChange={(e) => setFilter(e.target.value)}> */}
				{/* <option value="null">Seleziona un filtro</option> */}
				{/* </select> */}

				<div className="wrapper-input-group w-auto d-inline-block mx-2">
					<div className="input-group">
						<input className="form-control" placeholder="Cerca" onChange={(e) => setSearch(e.target.value)} />
						<input className="btn btn-primary" type="submit" value="Cerca" onClick={handleSearch} />
					</div>
				</div>
			</div>

			<hr />

			<nav className="pagination-section">
				<ul className="pagination justify-content-center">
					{pagination}
				</ul>
			</nav>

			<table className="table table-striped">
				<thead className="thead-dark">
					<tr>
						<th></th>
						<th>Nome Banca</th>
						<th>PEC Banca</th>
						<th style={{width:"25%"}}>Sede Centrale</th>
						<th>Data Creazione</th>
					</tr>
				</thead>
				<tbody>
					{banks !== null ?
						banks.map((item, index) => {
							return (
								<tr key={index}>
									<td>
										<div className="">
										<NavLink to={`${props.match.path}/${item._id}`} className="btn btn-secondary"><FontAwesomeIcon icon={faEdit} /></NavLink>
										<button type="button" onClick={() => handleDeleteBank(item._id)} className="mx-2 btn btn-danger"><FontAwesomeIcon icon={faTrash} /></button>
										</div>
									</td>
									<td className="text-uppercase">{item.name}</td>
									<td>{item.pec.map((itemPec,pecKey)=>{
										return (
											<span className='d-block py-1' key={pecKey}>
											{itemPec}
											</span>
										)
									})}</td>
									<td className="text-uppercase">{item.headquarters ? item.headquarters : "N.D."}</td>
									<td className="text-uppercase">{moment(item.created_at).format('DD/MM/YYYY')}</td>
								</tr>
							)
						})
						: null}
				</tbody>
			</table>
			{showNewBank ? <NewBank setShowNewBank={setShowNewBank} setBanks={setBanks} /> : null}
		</div>
	)
}

export default ListBanks;